export default {"src":"/_next/static/media/data-flow-mapping.5635fb44.svg","height":499,"width":499,"blurWidth":0,"blurHeight":0};